import {Grid} from '@material-ui/core';
import {SwitchCustom, TextBox} from '../../../Core/UI';
import React from 'react';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import {CategoryCard} from '../CategoryCard';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';
import {SelectInputElement} from '../../PreQualification/Components/SelectInputElement';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/ApprovalXref';

type IdentityProps = {
    valueChanged: (p?: Parameter, value?: any) => void;
    parameters: Approval;
    setCategory: (entry: string) => void;
    index: number;
};

const Identity = observer(({valueChanged, parameters, setCategory, index}: IdentityProps) => {
    const required = (value?: string) => (
        <span>
            {value && value} <span style={{color: 'red'}}>*</span>
        </span>
    );

    return (
        <CategoryCard title={'Identity'} setCategory={setCategory} index={index}>
            <Grid item xs={4}>
                <TextBox
                    id={'birthCountry'}
                    label={required('Birth Country')}
                    value={parameters.birthCountry?.value}
                    onChange={(value) => valueChanged(parameters.birthCountry, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'Birth State',
                        name: 'birthState',
                        options: fieldOptions.birthState.options,
                        ...parameters.birthState,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id={'birthCity'}
                    label={'Birth City'}
                    value={parameters.birthCity?.value}
                    onChange={(value) => valueChanged(parameters.birthCity, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <TextBox
                    id={'birthAddressZipCode'}
                    label={'Birth City Zipcode'}
                    value={parameters.birthAddressZipCode?.value}
                    onChange={(value) => valueChanged(parameters.birthAddressZipCode, value)}
                />
            </Grid>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'U.S. Citizenship',
                        name: 'usCitizenship',
                        options: fieldOptions.usCitizenship.options,
                        ...parameters.usCitizenship,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            <>
                {parameters.usCitizenship.value === 'PermanentResident' && (
                    <Grid item xs={4}>
                        <TextBox
                            id={'usPermResNumber'}
                            label={required('What is your permanent resident card number?')}
                            value={parameters.usPermResNumber?.value}
                            onChange={(value) => valueChanged(parameters.usPermResNumber, value)}
                        />
                    </Grid>
                )}
            </>
            <>
                {parameters.usCitizenship.value === 'USVisaHolder' && (
                    <>
                        <Grid item xs={4}>
                            <TextBox
                                id={'usVisaType'}
                                label={required('What type of visa?')}
                                value={parameters.usVisaType?.value}
                                onChange={(value) => valueChanged(parameters.usVisaType, value)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextBox
                                id={'usVisaNumber'}
                                label={required('What is your visa number?')}
                                value={parameters.usVisaNumber?.value}
                                onChange={(value) => valueChanged(parameters.usVisaNumber, value)}
                            />
                        </Grid>
                    </>
                )}
            </>
            <>
                {parameters.usCitizenship.value === 'NoUSVisaTINonly' && (
                    <Grid item xs={4}>
                        <TextBox
                            id={'usTinNumber'}
                            label={required('What is your TIN number?')}
                            value={parameters.usTinNumber?.value}
                            onChange={(value) => valueChanged(parameters.usTinNumber, value)}
                        />
                    </Grid>
                )}
            </>
            <Grid item xs={4}>
                <SelectInputElement
                    param={{
                        label: 'DL Status',
                        name: 'validDriversLicense',
                        options: fieldOptions.validDriversLicense.options,
                        ...parameters.validDriversLicense,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            <>
                {parameters.validDriversLicense.value === 'NoID' && (
                    <Grid item xs={12}>
                        <TextBox
                            id={'ndiReason'}
                            label="Reason for not having any ID."
                            value={parameters.ndiReason?.value}
                            onChange={(value) => valueChanged(parameters.ndiReason, value)}
                        />
                    </Grid>
                )}
            </>
            <>
                {parameters.validDriversLicense.value === 'Yes' && (
                    <>
                        <Grid item xs={4}>
                            <SelectInputElement
                                param={{
                                    label: 'DL Issue State',
                                    name: 'driversLicenseState',
                                    options: fieldOptions.driversLicenseState.options,
                                    ...parameters.driversLicenseState,
                                }}
                                required={required('')}
                                valueChanged={valueChanged}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextBox
                                id={'driversLicenseNumber'}
                                label={required('DL Number')}
                                value={parameters.driversLicenseNumber?.value}
                                onChange={(value) => valueChanged(parameters.driversLicenseNumber, value)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextBox
                                id={'driversLicExpiration'}
                                label={required('DL Expiration')}
                                value={parameters.driversLicExpiration?.value}
                                onChange={(value) => valueChanged(parameters.driversLicExpiration, value)}
                            />
                        </Grid>
                    </>
                )}
            </>
            <>
                {parameters.validDriversLicense.value === 'StateID' && (
                    <>
                        <Grid item xs={4}>
                            <SelectInputElement
                                param={{
                                    label: 'State of Issue',
                                    name: 'stateIdState',
                                    options: fieldOptions.stateIdState.options,
                                    ...parameters.stateIdState,
                                }}
                                required={required('')}
                                valueChanged={valueChanged}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextBox
                                id={'stateIdNumber'}
                                label={required('State ID #')}
                                value={parameters.stateIdNumber?.value}
                                onChange={(value) => valueChanged(parameters.stateIdNumber, value)}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextBox
                                id={'stateIdExpiration'}
                                label={required('State ID Expiration')}
                                value={parameters.stateIdExpiration?.value}
                                onChange={(value) => valueChanged(parameters.stateIdExpiration, value)}
                            />
                        </Grid>
                    </>
                )}
            </>
            <>
                {(parameters.validDriversLicense.value === 'StateID' ||
                    parameters.validDriversLicense.value === 'NoIDApplicantisaMinor' ||
                    parameters.validDriversLicense.value === 'NoID') && (
                    <>
                        <Grid item xs={4}>
                            <SelectInputElement
                                param={{
                                    label: 'Reason for No License',
                                    name: 'noDriversLicenseReason',
                                    options: fieldOptions.noDriversLicenseReason.options,
                                    ...parameters.noDriversLicenseReason,
                                }}
                                required={required('')}
                                valueChanged={valueChanged}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextBox
                                id={'modeOfTransport'}
                                label={required('Primary mode of Transport')}
                                value={parameters.modeOfTransport?.value}
                                onChange={(value) => valueChanged(parameters.modeOfTransport, value)}
                            />
                        </Grid>
                    </>
                )}
            </>
            <Grid item xs={4}>
                <SwitchCustom
                    param={{
                        name: 'military',
                        label: 'Member of a Military Org',
                        ...parameters.military,
                    }}
                    required={required('')}
                    valueChanged={valueChanged}
                />
            </Grid>
            <>
                {parameters.military.value === true && (
                    <>
                        <Grid item xs={4}>
                            <SelectInputElement
                                param={{
                                    label: 'Branch of service',
                                    name: 'militaryServiceBranch',
                                    options: fieldOptions.militaryServiceBranch.options,
                                    ...parameters.militaryServiceBranch,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <SelectInputElement
                                param={{
                                    label: 'Service status',
                                    name: 'militaryServieStatus',
                                    options: fieldOptions.militaryServieStatus.options,
                                    ...parameters.militaryServieStatus,
                                }}
                                required={''}
                                valueChanged={valueChanged}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextBox
                                id={'militaryServePeriod'}
                                label={'Years served in the military'}
                                value={parameters.militaryServePeriod?.value}
                                onChange={(value) => valueChanged(parameters.militaryServePeriod, value)}
                            />
                        </Grid>
                    </>
                )}
            </>
        </CategoryCard>
    );
});

export default Identity;
